import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Cursor from "./Cursor";
import useSmoothScroll from "../../hooks/useSmoothScroll";

export default function Layout() {
  useSmoothScroll();
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [loc.pathname]);

  return (
    <div className="App">
      <Cursor />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
